import React, { useEffect, useState } from 'react';
import { Progress, Typography } from 'antd';
import styles from './progresscircle.module.sass';
import AnimatedCounter from '../AnimatedCounter';

const ProgressCircle = (props) => {
  const { Title } = Typography;
  const [percent, setPercent] = useState(0);
  const [amount, setAmount] = useState(0);

  useEffect(() => {
    setTimeout(() => {
      setPercent(props.percent);
      setAmount(props.amount);
    }, 500);
  });

  return (
    <div className={styles.progress_circle}>
      <Progress
        className={styles.circle}
        percent={percent}
        type="dashboard"
        width={220}
        strokeWidth={12}
        strokeColor={'#3C9AE8'}
        trailColor={'#1A2F3A'}
        showInfo={false}
      />
      <div className={styles.display_numbers}>
        <Title level={3}>
          <AnimatedCounter
            serial="1"
            number={amount ? amount : 0}
            duration={1}
            delay={0}
          ></AnimatedCounter>
          <br></br>
        </Title>
        <p>left</p>
      </div>

      <p className={styles.description}>Request usage this day</p>
    </div>
  );
};

export default ProgressCircle;
